import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import compose from 'recompose/compose';
import { bool, func, string, arrayOf, object } from 'prop-types';
import { withStyles } from '@material-ui/core';

import { hasCRUDPermissions } from '../../../../utils';
import { PERMISSION_APIS_PRODUCT } from '../../../../constants';
import AddApis from './add.js';
import EditApis from './edit.js'
import styles from './styles';

export const Apis = (props) => {
  const {
    productUuid,
    isCurrentTab,
    notifyMessages,
    userContext,
  } = props;

  const [page, setPage] = useState('edit');

  const hasRead = hasCRUDPermissions(userContext, ['READ'], PERMISSION_APIS_PRODUCT);
  const hasUpdate = hasCRUDPermissions(userContext, ['UPDATE'], PERMISSION_APIS_PRODUCT);

  useEffect(() => {
    if (isCurrentTab) {
      if(!hasRead) {
        props.push('/404');
      }
    }
  }, [isCurrentTab, userContext]);

  const onPageChange = (value) => {
    setPage(value)
  }
  
  return (
    <>
      {page === 'edit' ?
        <EditApis
          productUuid={productUuid}
          isCurrentTab={isCurrentTab}
          onPageChange={onPageChange}
          notifyMessages={notifyMessages}
          hasUpdate={hasUpdate}
          push={props.push}
        />
      :
        <AddApis
          productUuid={productUuid}
          isCurrentTab={isCurrentTab}
          onPageChange={onPageChange}
        />
      }
    </>
  )
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

Apis.propTypes = {
  productUuid: string,
  isCurrentTab: bool,
  notifyMessages: func,
  userContext: arrayOf(object),
  push: func,
};

Apis.displayName = 'Apis';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Apis);
